import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        <div className='footer-section'>
            <footer>
                <h1>Copyright@Md.Khademul Islam</h1>
                <p>rkhademul8@gmail.com</p>
            </footer>
        </div>
    );
};

export default Footer;